/**
 * Inject or update a JSON-LD <script> tag in document head.
 * Used to add Schema.org structured data for SEO (Google rich results).
 */
export function injectJsonLd(id, data) {
  if (typeof document === "undefined") return;
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function removeJsonLd(id) {
  if (typeof document === "undefined") return;
  const el = document.getElementById(id);
  if (el) el.remove();
}

const ORG = {
  "@type": "Organization",
  "name": "Institut Impact Élite Martial",
  "url": typeof window !== "undefined" ? window.location.origin : "",
  "founder": {
    "@type": "Person",
    "name": "Ralph David Jean-Pierre",
    "jobTitle": "Kru, Officiel certifié Lumpinee Stadium",
  },
};

export const SCHEMA_ORG = ORG;
